export const SCOPES = [
  'https://www.googleapis.com/auth/webmasters.readonly'
];
